import { render, staticRenderFns } from "./PurchasesDetailModal.vue?vue&type=template&id=02189548"
import script from "./PurchasesDetailModal.vue?vue&type=script&lang=js"
export * from "./PurchasesDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports